import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {NavigationView} from 'app/shared/model/navigation-view';
import {NavigationElement} from 'app/shared/model/navigation-element';
import {NavigationPath} from 'app/shared/model/navigation-path';

@Injectable({
    providedIn: 'root'
})

export class NavigationStore {

    private currentView$: BehaviorSubject<NavigationView> = new BehaviorSubject<NavigationView>(NavigationView.DASHBOARD);
    private path$: BehaviorSubject<NavigationPath[]> = new BehaviorSubject<NavigationPath[]>([]);

    constructor(
        private router: Router,
    ) {
    }

    setCurrentView(view: NavigationView) {
        this.currentView$.next(view);
    }

    getCurrentView() {
        return this.currentView$.asObservable();
    }

    getCurrentViewSnapshot() {
        return this.currentView$.getValue();
    }

    initNavigationPath() {
        this.path$.next([]);
    }

    setPathFromTree(tree: NavigationElement, id: string) {
        const path: NavigationPath[] = [];
        this.extractPathFromTree(tree, id, path);
        this.path$.next(path.reverse());
    }

    getPath() {
        return this.path$.asObservable();
    }

    private extractPathFromTree(root: NavigationElement, id: string, path: NavigationPath[]) {

        if (!root) {
            return false;
        }

        // Cas d'un ouvrage (onglet document)
        if (root.typeElement === 'OUVRAGE') {
            path.push({active: root.canAccess, name: root.nom, element: root});
            return true;
        }

        // On cherche un noeud avec l'id passé en paramètre (noeud courant, ou sous-noeuds récursivement)
        if (root.id === id || (root.children && root.children.some(child => this.extractPathFromTree(child, id, path)))) {
            path.push({active: root.canAccess, name: root.nom, element: root});
            return true;
        }

        return false;
    }

}

